import { isNil } from 'lodash';

export const maskEmail = (email: string = ''): string => {
    if (isNil(email)) {
        return '';
    }

    const [localPart, domain] = email.split('@');

    if (!localPart || !domain) {
        return '';
    }

    const maskedLocalPart = localPart.slice(0, 4) + '****' + localPart.slice(-4);
    return `${maskedLocalPart}@${domain}`;
};
